import { BankAccountManager } from "./BankAccountManager";
import { PaymentSettlementSettings } from "./PaymentSettlementSettings";

export function PaymentsTab() {
  return (
    <div className="space-y-4">
      <BankAccountManager />
      <PaymentSettlementSettings />
    </div>
  );
}
